var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyStacks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L5 7L12 10L19 7L12 4Z",
    stroke: "#C2CFE0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34277 10.1797L4.70456 11.3103C4.4288 11.4285 4.25 11.6997 4.25 11.9997C4.25 12.2997 4.4288 12.5709 4.70456 12.6891L11.7046 15.6891C11.8932 15.7699 12.1068 15.7699 12.2954 15.6891L19.2954 12.6891C19.5712 12.5709 19.75 12.2997 19.75 11.9997C19.75 11.6997 19.5712 11.4285 19.2954 11.3103L16.6572 10.1797L14.7533 10.9957L17.0961 11.9997L12 14.1837L6.90394 11.9997L9.24671 10.9957L7.34277 10.1797Z",
    fill: "#C2CFE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34277 15.1797L4.70456 16.3103C4.4288 16.4285 4.25 16.6997 4.25 16.9997C4.25 17.2997 4.4288 17.5709 4.70456 17.6891L11.7046 20.6891C11.8932 20.7699 12.1068 20.7699 12.2954 20.6891L19.2954 17.6891C19.5712 17.5709 19.75 17.2997 19.75 16.9997C19.75 16.6997 19.5712 16.4285 19.2954 16.3103L16.6572 15.1797L14.7533 15.9957L17.0961 16.9997L12 19.1837L6.90394 16.9997L9.24671 15.9957L7.34277 15.1797Z",
    fill: "#C2CFE0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyStacks);
export default __webpack_public_path__ + "static/media/grey-stacks.7c9b2ea88143f161c58941fc5d597430.svg";
export { ForwardRef as ReactComponent };